export default "__VITE_ASSET__CpQ6FPsZ__"